/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./airdropInviter.vue?vue&type=template&id=01aff051&scoped=true"
import script from "./airdropInviter.vue?vue&type=script&lang=js"
export * from "./airdropInviter.vue?vue&type=script&lang=js"
import style1 from "./airdropInviter.vue?vue&type=style&index=1&id=01aff051&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01aff051",
  null
  
)

export default component.exports